import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {NGXLogger} from 'ngx-logger';
import {Observable, of as observableOf} from 'rxjs';

import {catchError} from 'rxjs/operators';
import {SessionService} from '../../../shared/service/session.service';

import {SensorLogInterface} from '../model/sensor-log.model';
import {SensorService} from '../service/sensor.service';

@Injectable()
export class SensorLogResolver {

  constructor(private logger: NGXLogger,
              private sessionService: SessionService,
              private sensorDataService: SensorService,
              private router: Router) {
    this.logger.debug('constructing SensorLog resolver.');
  }

  resolve(route: ActivatedRouteSnapshot,
          state: RouterStateSnapshot): Observable<SensorLogInterface> {
    this.logger.debug(
      'SensorLogResolver: Waiting for sensor data to be available.');

    return this.sensorDataService.getAllSensorLogs(this.sessionService.getCurrentSensor().id).pipe(catchError((error) => {
      if (error === 404) {
        this.router.navigate(['404']);
      } else {
        this.router.navigate(['error']);
      }
      return observableOf(null);
    }));
  }
}
